var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNegativeCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4282 17.9167C29.7466 17.9167 17.8449 29.8185 17.8449 44.5001C17.8449 59.1816 29.7466 71.0834 44.4282 71.0834C59.1098 71.0834 71.0115 59.1816 71.0115 44.5001C71.0115 29.8185 59.1098 17.9167 44.4282 17.9167ZM11.8449 44.5001C11.8449 26.5048 26.4329 11.9167 44.4282 11.9167C62.4235 11.9167 77.0116 26.5048 77.0116 44.5001C77.0116 62.4953 62.4235 77.0834 44.4282 77.0834C26.4329 77.0834 11.8449 62.4953 11.8449 44.5001ZM33.4319 33.5037C34.6035 32.3322 36.503 32.3322 37.6745 33.5037L44.4282 40.2574L51.1819 33.5037C52.3535 32.3322 54.253 32.3322 55.4245 33.5037C56.5961 34.6753 56.5961 36.5748 55.4245 37.7464L48.6709 44.5001L55.4245 51.2537C56.5961 52.4253 56.5961 54.3248 55.4245 55.4964C54.253 56.6679 52.3535 56.6679 51.1819 55.4964L44.4282 48.7427L37.6745 55.4964C36.503 56.6679 34.6035 56.6679 33.4319 55.4964C32.2603 54.3248 32.2603 52.4253 33.4319 51.2537L40.1856 44.5001L33.4319 37.7464C32.2603 36.5748 32.2603 34.6753 33.4319 33.5037Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegativeCheck);
export default __webpack_public_path__ + "static/media/negativeCheck.abfdcd56.svg";
export { ForwardRef as ReactComponent };